import React from 'react';
import { CalendarIcon, ClipboardListIcon, HeartIcon } from 'lucide-react';
export function ProcessSteps() {
  return <section id="process" className="py-16 bg-[#9BAB6C]" data-id="element-285">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286">
        <div className="text-center mb-16" data-id="element-287">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-288">
            How It Works
          </h2>
          <p className="text-xl text-white max-w-3xl mx-auto" data-id="element-289">
            A simple, straightforward process to get your bookkeeping on track
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-290">
          {/* Step 1 */}
          <div className="bg-white rounded-lg p-8 relative hover:shadow-lg transition-shadow" data-id="element-291">
            <div className="absolute -top-5 -left-5 h-12 w-12 rounded-full bg-[#3A4A46] text-white flex items-center justify-center text-xl font-bold" data-id="element-292">
              1
            </div>
            <div className="mb-6 text-[#8A9A5B]" data-id="element-293">
              <CalendarIcon className="h-12 w-12" data-id="element-294" />
            </div>
            <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-295">
              Schedule a Free Discovery Call
            </h3>
            <p className="text-gray-600" data-id="element-296">
              Tell me about your business, your current setup, and your goals.
              No pressure, just a helpful conversation.
            </p>
          </div>
          {/* Step 2 */}
          <div className="bg-white rounded-lg p-8 relative hover:shadow-lg transition-shadow" data-id="element-297">
            <div className="absolute -top-5 -left-5 h-12 w-12 rounded-full bg-[#3A4A46] text-white flex items-center justify-center text-xl font-bold" data-id="element-298">
              2
            </div>
            <div className="mb-6 text-[#8A9A5B]" data-id="element-299">
              <ClipboardListIcon className="h-12 w-12" data-id="element-300" />
            </div>
            <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-301">
              Get a Clear Proposal
            </h3>
            <p className="text-gray-600" data-id="element-302">
              I'll recommend the best package for your needs - flat-rate,
              transparent pricing with onboarding included.
            </p>
          </div>
          {/* Step 3 */}
          <div className="bg-white rounded-lg p-8 relative hover:shadow-lg transition-shadow" data-id="element-303">
            <div className="absolute -top-5 -left-5 h-12 w-12 rounded-full bg-[#3A4A46] text-white flex items-center justify-center text-xl font-bold" data-id="element-304">
              3
            </div>
            <div className="mb-6 text-[#8A9A5B]" data-id="element-305">
              <HeartIcon className="h-12 w-12" data-id="element-306" />
            </div>
            <h3 className="text-xl font-bold text-[#3A4A46] mb-4" data-id="element-307">
              Breathe Easy - Your Books Are Handled
            </h3>
            <p className="text-gray-600" data-id="element-308">
              Whether it's ongoing bookkeeping or a one-time clean-up, I'll get
              your numbers in order so you can focus on what matters most.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-309">
          <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-opacity-90 transition-colors" data-id="element-310">
            Book a Free Discovery Call
          </a>
        </div>
      </div>
    </section>;
}